import { AccessControlResourcePatchRequest } from '@futrli-sdk/predict';

import { consolidatedForecastsQueryKey } from '../queries/consolidatedForecasts';
import { createMutation } from '../utils/mutations';
import { forecastsQueryKey } from '../queries/forecasts';
import { liveReportsQueryKey } from '../queries/liveReports';
import { queryClient } from '../core/queryClient';
import { reportTemplatesQueryKey } from '../queries/reportTemplates';
import { resourcePermissionsQueryKey } from '../queries/sharing';
import { SharingEntityType, updateResourcePermissions } from '../../predict/src/core/api/sharing';

type UpdateResourcePermissionsResult = Awaited<ReturnType<typeof updateResourcePermissions>>;

export const updateResourcePermissionsMutation = (
  workspaceId: string,
  organisationId: string,
  entityType: SharingEntityType,
  entityId: string,
  isConsolidation = false
) =>
  createMutation<Partial<AccessControlResourcePatchRequest>, UpdateResourcePermissionsResult>({
    mutationFn: data =>
      updateResourcePermissions(workspaceId, organisationId, entityType, entityId, data, isConsolidation),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: resourcePermissionsQueryKey(organisationId, workspaceId, entityType, entityId, isConsolidation)
      });

      switch (entityType) {
        case 'live-report':
          queryClient.invalidateQueries({
            queryKey: liveReportsQueryKey(organisationId, workspaceId, isConsolidation)
          });
          break;
        case 'report-template':
          queryClient.invalidateQueries({
            queryKey: reportTemplatesQueryKey(organisationId, workspaceId, isConsolidation)
          });
          break;
        case 'forecast':
          queryClient.invalidateQueries({ queryKey: forecastsQueryKey(organisationId, workspaceId) });
          break;
        case 'consolidated-forecast':
          queryClient.invalidateQueries({ queryKey: consolidatedForecastsQueryKey(organisationId, workspaceId) });
          break;
        default:
          break;
      }
    }
  });
